export const couponsConstants = {
  SET_COUPONS_LOADING: 'coupons/SET_COUPONS_LOADING',
  SET_COUPONS: 'coupons/SET_COUPONS',
  GET_COUPONS: 'coupons/GET_COUPONS',
  EXPORT_COUPONS: 'coupons/EXPORT_COUPONS',
  EXPORT_COUPONS_ASYNC: 'coupons/EXPORT_COUPONS_ASYNC',
  EXPORT_COUPONS_CODE_BY_CODE: 'coupons/EXPORT_COUPONS_CODE_BY_CODE',
  SET_COUPONS_EXPORT_IDENTIFIER: 'coupons/SET_COUPONS_EXPORT_IDENTIFIER',
  SET_PENDING_COUPON_CREATION: 'coupons/SET_PENDING_COUPON_CREATION',
  CLEAR_PENDING_COUPON_CREATION: 'coupons/CLEAR_PENDING_COUPON_CREATION',
  CLEAR_COUPONS: 'coupons/CLEAR_COUPONS',
  GET_COUPON: 'coupons/GET_COUPON',
  SET_COUPON: 'coupons/SET_COUPON',
  CREATE_COUPON: 'coupons/CREATE_COUPON',
  EDIT_COUPON: 'coupons/EDIT_COUPON',
};
